import api from "Common/Client/Interceptor";

export const getReportSummaryData = () => {
    return api.get('/indv/reports/Summary')
}